import { ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#FAFCF9]">
      {/* Soft botanical background */}
      <div className="absolute inset-0">
        <div className="absolute top-10 left-0 h-96 w-96 rounded-full bg-[#6B8E5F]/10 blur-3xl" />
        <div className="absolute bottom-0 right-0 h-[28rem] w-[28rem] rounded-full bg-[#E8DCC8]/50 blur-3xl" />
      </div>

      <div className="relative mx-auto flex min-h-[calc(100vh-120px)] max-w-7xl flex-col items-center gap-16 px-6 py-20 lg:flex-row">
        {/* Left content */}
        <div className="flex-1 text-center lg:text-left">
          <span className="inline-flex rounded-full bg-[#6B8E5F]/10 px-4 py-2 text-sm font-medium text-[#557149]">
            Curated Living • Books • Coffee • Greens
          </span>

          <h1 className="mt-8 text-5xl font-semibold leading-tight text-[#1F2937] md:text-7xl">
            Cultivate
            <br />
            Better
            <br />
            Everyday Living.
          </h1>

          <p className="mt-8 max-w-xl text-lg leading-8 text-gray-600">
            Thoughtfully selected books, specialty coffee, apparel, and living
            greens for slower mornings and intentional spaces.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <button className="rounded-full bg-[#6B8E5F] px-8 py-4 font-medium text-white transition hover:bg-[#557149]">
              Shop Collection
            </button>

            <button className="flex items-center justify-center gap-2 rounded-full border border-[#6B8E5F]/20 bg-white px-8 py-4 font-medium transition hover:border-[#6B8E5F]">
              Explore Journal
              <ArrowRight size={18} />
            </button>
          </div>
        </div>

        {/* Right editorial collage */}
        <div className="relative flex-1 h-[650px] hidden lg:block">
          <img
            src="/images/coffee.jpg"
            alt="Coffee"
            className="absolute top-0 left-10 h-72 w-56 rounded-3xl object-cover shadow-xl"
          />

          <img
            src="/images/books.jpg"
            alt="Books"
            className="absolute top-24 right-0 h-80 w-64 rounded-3xl object-cover shadow-xl"
          />

          <img
            src="/images/plants.jpg"
            alt="Plants"
            className="absolute bottom-0 left-0 h-64 w-64 rounded-3xl object-cover shadow-xl"
          />

          <img
            src="/images/clothing.jpg"
            alt="Apparel"
            className="absolute bottom-10 right-16 h-72 w-52 rounded-3xl object-cover shadow-xl"
          />
        </div>
      </div>
    </section>
  );
}